"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { CircleCheck, PenTool, Hammer, Key } from "lucide-react";
export default function OurApproach() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const steps = [{
    id: 1,
    number: "01",
    title: "Consultation",
    description: "We begin by understanding your vision, needs, and the unique characteristics of your site. This phase establishes trust and clarifies expectations.",
    icon: CircleCheck
  }, {
    id: 2,
    number: "02",
    title: "Design",
    description: "Thoughtful design decisions are made collaboratively. We focus on long-term performance, spatial harmony, and material integrity.",
    icon: PenTool
  }, {
    id: 3,
    number: "03",
    title: "Construction",
    description: "With hands-on oversight, we build with precision and care. Clean job sites, clear communication, and quality craftsmanship define this phase.",
    icon: Hammer
  }, {
    id: 4,
    number: "04",
    title: "Hand-over",
    description: "Upon completion, we walk you through every detail, ensuring confidence in your new home. Our commitment extends beyond the final inspection.",
    icon: Key
  }];
  return <section className="bg-dark-background py-16 md:py-24">
      <div className="container mx-auto px-6 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-foreground-dark font-display text-3xl md:text-4xl font-semibold mb-4">
            Our Approach
          </h2>
          <p className="text-foreground-dark/80 text-base md:text-lg max-w-2xl mx-auto">
            A clear, step-by-step process that ensures transparency, quality, and confidence at every stage.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 gap-6 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {steps.map((step, i) => {
          const IconComponent = step.icon;
          return <Card key={step.id} data-index={i} className="bg-muted-dark-background border-border hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] px-6 py-6">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0 flex flex-col items-center">
                    <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center text-foreground-primary font-display font-semibold text-lg mb-2">
                      {step.number}
                    </div>
                    {i < steps.length - 1 && <Separator orientation="vertical" className="h-12 bg-border w-px my-2" />}
                  </div>
                  <div className="flex-1 pt-1">
                    <div className="flex items-center gap-3 mb-3">
                      <IconComponent className="w-5 h-5 text-primary" />
                      <h3 className="text-foreground-dark font-display text-xl font-semibold">
                        {step.title}
                      </h3>
                    </div>
                    <p className="text-foreground-dark/80 text-sm md:text-base leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}